import React from 'react';
import { useTranslation } from 'react-i18next';
import superagent from 'superagent';

// Styles
import styles from '../index.module.sass';

const Branches = (props) => {
  const { branches } = props;
  const { t } = useTranslation('branch');

  const branchItems = t('branches', { returnObjects: true });

  function downloadItem(url, name) {
    superagent
      .get(url)
      .responseType('blob')
      .then((response) => {
        const blob = new Blob([response.body], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = name;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch(console.error);
  }

  return (
    <div className={styles.branchContainer}>
      {branchItems.map((val, key) => {
        const { title = '', field = '' } = val;
        return (
          <div key={key} className={styles.linkOption}>
            {(branches[field] && (
              <div className={styles.option} onClick={() => downloadItem(branches[field], title)}>
                {title}
              </div>
            )) || <div className={`${styles.option} ${styles.nolink}`}>{title}</div>}
          </div>
        );
      })}
    </div>
  );
};

export default Branches;
